export default function getQuestionFormatLabel(f) {
  switch (f) {
    case 'multiple_selection':
      return 'Selección Múltiple';
    case 'simple_selection':
      return 'Selección Simple';
    case 'true_or_false':
      return 'Verdadero o Falso';
  }
}
